"use client";
import { useMediaQuery } from "usehooks-ts";

const useSizes = () => {
  const maxSm = useMediaQuery("(max-width: 640px)");
  const maxMd = useMediaQuery("(max-width: 768px)");
  const maxLg = useMediaQuery("(max-width: 1024px)");

  return { maxSm, maxMd, maxLg };
};

export default useSizes;
